import template from './objectivesQuestion.html';
import controller from './objectivesQuestionCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanId: '<',
    familyId: '<',
    questionList: '<',
    questionId: '<',
    updateQuestion: '&',
    hideQuestion: '<',
    isObjectiveQuestion: '<',
    isHideSubQuestionBackground: '<',
  },
};
